import React, { useState } from 'react';

interface CompaniesPanelProps {
  companyAreas: Record<'Fischer' | 'Unitax', string[]>;
  onAddArea: (company: 'Fischer' | 'Unitax', area: string) => void;
}

export function CompaniesPanel({ companyAreas, onAddArea }: CompaniesPanelProps) {
  const [newAreaFischer, setNewAreaFischer] = useState('');
  const [newAreaUnitax, setNewAreaUnitax] = useState('');

  const addArea = (company: 'Fischer' | 'Unitax', area: string) => {
    const trimmed = area.trim();
    if (!trimmed) return;
    onAddArea(company, trimmed);
    if (company === 'Fischer') {
      setNewAreaFischer('');
    } else {
      setNewAreaUnitax('');
    }
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-lg font-semibold text-slate-900 mb-3">Fischer</h2>
          <p className="text-slate-600 text-sm mb-4">Áreas disponibles para colaboradores con empresa Fischer.</p>
          <div className="space-y-2">
            {companyAreas.Fischer.map((area) => (
              <div key={area} className="px-4 py-2 bg-slate-50 rounded border border-slate-200 text-sm text-slate-700">
                {area}
              </div>
            ))}
          </div>
          <div className="mt-4 flex gap-2">
            <input
              value={newAreaFischer}
              onChange={(e) => setNewAreaFischer(e.target.value)}
              placeholder="Nueva área Fischer"
              className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-fycom-navy"
            />
            <button
              onClick={() => addArea('Fischer', newAreaFischer)}
              className="px-4 py-2 bg-fycom-navy text-white rounded-lg text-sm hover:bg-blue-900 transition"
            >
              Agregar
            </button>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-lg font-semibold text-slate-900 mb-3">Unitax</h2>
          <p className="text-slate-600 text-sm mb-4">Áreas disponibles para colaboradores con empresa Unitax.</p>
          <div className="space-y-2">
            {companyAreas.Unitax.map((area) => (
              <div key={area} className="px-4 py-2 bg-slate-50 rounded border border-slate-200 text-sm text-slate-700">
                {area}
              </div>
            ))}
          </div>
          <div className="mt-4 flex gap-2">
            <input
              value={newAreaUnitax}
              onChange={(e) => setNewAreaUnitax(e.target.value)}
              placeholder="Nueva área Unitax"
              className="flex-1 px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-fycom-navy"
            />
            <button
              onClick={() => addArea('Unitax', newAreaUnitax)}
              className="px-4 py-2 bg-fycom-navy text-white rounded-lg text-sm hover:bg-blue-900 transition"
            >
              Agregar
            </button>
          </div>
        </div>
      </div>

      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 text-sm text-slate-600">
        <p className="font-semibold text-slate-900">Nota:</p>
        <p>Las áreas agregadas aquí se usarán en el selector de colaboradores cuando la empresa sea Fischer o Unitax.</p>
      </div>
    </div>
  );
}
